var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "pdfPopupNavbar"
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg")
    },
    on: {
      "click": _vm.hidePdfGenerator
    }
  }), !_vm.generatingPdf ? _c('div', {
    staticClass: "w-button pointer",
    on: {
      "click": _vm.generate
    }
  }, [_vm._v(" GENEROVAŤ ")]) : _c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  })], 1), _c('div', {
    staticClass: "body",
    attrs: {
      "id": "clientFinancingNeeds"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo"
  }), _c('div', {
    staticClass: "subeheading"
  }, [_vm._v("jednoznačne najrýchlejšia a najvýhodnejšia hypotéka, "), _c('span', {
    staticClass: "ucel"
  }, [_vm._v(_vm._s(_vm.purposeLabel) + " ")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("p. " + _vm._s(_vm.$store.getters["mortgageDetailState/getApplicant"].last_name))])])]), _vm._m(0), _vm._l(_vm.banksOffers, function (offer, index) {
    return offer.success ? _c('div', {
      key: index,
      staticClass: "mortgage-result-broker zok",
      style: {
        'mb-1': offer.length > 1
      }
    }, [_c('div', {
      staticClass: "mortgage-parameters zok"
    }, [_c('img', {
      staticClass: "bank-logo big",
      attrs: {
        "src": _vm.getBankImage(offer.extra.bank_code_name),
        "loading": "lazy",
        "alt": ""
      }
    }), _c('div', {
      staticClass: "bold wrap100px green"
    }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(offer.pozicana_suma)) + " € ")]), _c('div', {
      staticClass: "bold wrap50px"
    }, [_vm._v(_vm._s(offer.sadzba)), _c('span', {
      staticClass: "upper-index"
    }, [_vm._v("%")])]), _c('div', {
      staticClass: "bold wrap100px green"
    }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(offer.mesacna_splatka)) + " € ")]), _c('div', {
      staticClass: "bold wrap50px"
    }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(offer.popl_sprac_hypo)) + " € ")]), _c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(offer.splatnost_r) + " "), _c('span', {
      staticClass: "upper-index"
    }, [_vm._v("ROKOV")])]), _c('div', {
      staticClass: "bold wrap100px"
    }, [_vm._v(" " + _vm._s(offer.popl_za_vedenie_uctu) + " €"), _c('span', {
      staticClass: "upper-index"
    }, [_vm._v("/ mesiac")])]), _c('div', {
      staticClass: "bold wrap50px"
    }, [_vm._v(_vm._s(offer.fix))])]), _c('div', {
      staticClass: "discount-list"
    })]) : _vm._e();
  }), _c('div', {
    staticClass: "pagebreak"
  }), _c('div', {
    staticClass: "welcome-block"
  }, [_c('img', {
    staticClass: "agentimage",
    attrs: {
      "src": _vm.broker.profile_image ? _vm.broker.profile_image : 'https://uploads-ssl.webflow.com/641c1368683a584b0eb1d8a2/641dbf1cfcf9726751be633a_agent%20image.png'
    }
  }), _c('div', {
    staticClass: "message"
  }, [_c('div', [_vm._v("Volám sa "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.broker.first_name) + " " + _vm._s(_vm.broker.last_name))]), _vm._v(" a budem Váš osobný bankár. Ďalší postup je popísaný nižšie a na email som si dovolil Vám poslať pozvánku do našej aplikácie. ")])]), _c('div', {
    staticClass: "image"
  })]), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "pagebreak"
  }), _vm._m(4), _c('div', {
    staticClass: "welcome-block oposit"
  }, [_c('img', {
    staticClass: "agentimage oposit",
    attrs: {
      "src": _vm.broker.profile_image ? _vm.broker.profile_image : 'https://uploads-ssl.webflow.com/641c1368683a584b0eb1d8a2/641dbf1cfcf9726751be633a_agent%20image.png'
    }
  }), _vm._m(5)]), _vm._m(6)], 2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "results-legend zok"
  }, [_c('div', {
    staticClass: "break-40px"
  }), _c('p', [_vm._v("celkom")]), _c('p', [_vm._v("sadzba")]), _c('p', [_vm._v("splátka")]), _c('p', [_vm._v("poplatok")]), _c('p', [_vm._v("splatnosť")]), _c('p', [_vm._v("vedenie účtu")]), _c('p', [_vm._v("fixácia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-block"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('div', {
    staticClass: "bold big"
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Vyberte si")]), _vm._v(" najvýhodnejšie financovanie")]), _c('div', [_vm._v("nastavte si fixáciu alebo splatnosť podľa predstavy a sledujte ako sa ponuka prepočíta.")])]), _c('div', {
    staticClass: "step-number"
  }, [_c('div', [_vm._v("1")])]), _c('div', {
    staticClass: "mockupimg step-1"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-block"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('div', {
    staticClass: "bold big"
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Dohodnite si ")]), _vm._v("podpis vygenerovaných žiadostí")]), _c('div', [_vm._v("na vygenerovanie žiadostí však potrebujeme aby ste nám doplnili pár informácii o sebe, vašom príjme a výdavkoch ")])]), _c('div', {
    staticClass: "step-number"
  }, [_c('div', [_vm._v("2")])]), _c('div', {
    staticClass: "mockupimg _2step"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-block"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('div', {
    staticClass: "bold big"
  }, [_vm._v("Na záver "), _c('span', {
    staticClass: "green"
  }, [_vm._v("nahrajte podklady pre banku")])]), _c('div', [_vm._v("posledným krokom je nahranie podkladov na schvaľovanie do cloudu, ktorý automaticky identifikuje potrebné doklady a vyzve Vás na ich nahratie. ")])]), _c('div', {
    staticClass: "step-number"
  }, [_c('div', [_vm._v("3")])]), _c('div', {
    staticClass: "mockupimg _3step"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-block"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('div', {
    staticClass: "bold big"
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Hotovo")]), _vm._v(". O zvyšok sa postaráme")]), _c('div', [_vm._v("o priebehu schvaľovania ste informovaný emailovými a push notifikáciami, aby ste vždy vedeli v akej fáze procesu sa nachádzame. ")])]), _c('div', {
    staticClass: "step-number"
  }, [_c('div', [_vm._v("4")])]), _c('div', {
    staticClass: "mockupimg _4step"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message"
  }, [_c('div', [_vm._v("Možno sa pýtate prečo by ste mali využiť služby bankari.sk. Pripravil som pre Vás krátky zoznam benefitov. Keď budete mať otázky neváhajte sa so mnou spojiť."), _c('br')])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "benefit-block"
  }, [_c('div', {
    staticClass: "w-layout-grid grid-3-columns gap-32px"
  }, [_c('a', {
    staticClass: "card link-card feature-item-colored w-inline-block"
  }, [_c('div', {
    staticClass: "mg-bottom-32px greenbenefits"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "image-wrapper alignright"
  }, [_c('div', {
    staticClass: "image-2"
  })])])]), _c('div', {
    staticClass: "card-feature-item-content"
  }, [_c('h3', {
    staticClass: "color-neutral-100"
  }, [_vm._v("o 40% rýchlejšie")]), _c('p', [_vm._v("vďaka automatizácii spracujeme hypotéku o 40% rýchlejšie ako štandardný hypotekárny poradca")])])]), _c('a', {
    staticClass: "card link-card feature-item-colored w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "mg-bottom-32px greenbenefits"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "image-wrapper alignright"
  }, [_c('div', {
    staticClass: "image-2 uspesnost"
  })])])]), _c('div', {
    staticClass: "card-feature-item-content"
  }, [_c('h3', {
    staticClass: "color-neutral-100"
  }, [_vm._v("100% úspešnosť")]), _c('p', [_vm._v("hypotéku na mieru vypočíta na základe parametrov všetkých bánk náš sofistikovaný algoritmus na počkanie")])])]), _c('a', {
    staticClass: "card link-card feature-item-colored w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "mg-bottom-32px greenbenefits"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "image-wrapper alignright"
  }, [_c('div', {
    staticClass: "image-2 posudok"
  })])])]), _c('div', {
    staticClass: "card-feature-item-content"
  }, [_c('h3', {
    staticClass: "color-neutral-100"
  }, [_vm._v("právna pomoc")]), _c('p', [_vm._v("náš advokát Vám skontroluje rezervačnú a kúpnu zmluvu, ktorú Vám zašlú v prípade kúpy nehnuteľnosti")])])])])]);

}]

export { render, staticRenderFns }